(function () {
  if (window.__kartmaxCollectionPlpInitialized) {
    return;
  }

  window.__kartmaxCollectionPlpInitialized = true;

  // Capture while currentScript is available (theme asset base for skeleton PNGs).
  const KARTMAX_THEME_ASSET_BASE = (function () {
    const script = document.currentScript;
    const src = script && typeof script.src === "string" ? script.src : "";
    const idx = src.indexOf("/assets/");
    return idx === -1 ? "" : src.slice(0, idx + "/assets/".length);
  })();

  const CONFIG_SELECTOR = "[data-kartmax-collection-config]";
  const HIDDEN_CLASS = "kartmax-search-hidden";
  const CONTAINER_ID = "kartmax_container";
  const NATIVE_COLLECTION_BANNER_SELECTORS = [
    ".collection-hero",
    ".collection-banner",
    ".main-collection-banner",
    ".collection__title",
    ".collection-hero__title",
    ".collection__description",
    ".collection-hero__description",
  ];

  const DEFAULT_SORT_OPTIONS = [
    { value: "", label: "Featured" },
    { value: "selling_price:asc", label: "Price, low to high" },
    { value: "selling_price:desc", label: "Price, high to low" },
    { value: "name:asc", label: "Alphabetically, A-Z" },
    { value: "name:desc", label: "Alphabetically, Z-A" },
  ];

  const TROLLEY_ICON_SVG =
    '<svg class="icon icon--trolley" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" aria-hidden="true">' +
    '<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M6.6665 3.51997h2m0 0h2m-2 0V1.5m0 2.01997V5.5M1.49976 2h.924c.34 0 .63666.22867.72466.55667l.25534.958L4.99976 9.5m0 0h7.47864c.7474-1.53333 1.4-3.12267 1.9494-4.75867M4.99976 9.5c-.53044 0-1.03914.21071-1.41422.5858-.37507.3751-.58578.8838-.58578 1.4142H13.4998m-9.50004 2c0 .1326-.05268.2598-.14645.3536-.09377.0937-.22095.1464-.35355.1464-.13261 0-.25979-.0527-.35356-.1464-.09377-.0938-.14644-.221-.14644-.3536s.05267-.2598.14644-.3536c.09377-.0937.22095-.1464.35356-.1464.1326 0 .25978.0527.35355.1464.09377.0938.14645.221.14645.3536m7.64644.3536c-.0938-.0938-.1464-.221-.1464-.3536s.0526-.2598.1464-.3536c.0938-.0937.2209-.1464.3536-.1464.1326 0 .2597.0527.3535.1464.0938.0938.1465.221.1465.3536s-.0527.2598-.1465.3536c-.0938.0937-.2209.1464-.3535.1464-.1327 0-.2598-.0527-.3536-.1464"></path>' +
    "</svg>";

  // match theme Dirham icon (money-with-dirham).
  const DIRHAM_ICON_SVG =
    '<svg class="icon icon--dirham dirham-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 344.84 299.91" aria-hidden="true">' +
    '<path d="M342.14,140.96l2.7,2.54v-7.72c0-17-11.92-30.84-26.56-30.84h-23.41C278.49,36.7,222.69,0,139.68,0c-52.86,0-59.65,0-109.71,0,0,0,15.03,12.63,15.03,52.4v52.58h-27.68c-5.38,0-10.43-2.08-14.61-6.01l-2.7-2.54v7.72c0,17.01,11.92,30.84,26.56,30.84h18.44s0,29.99,0,29.99h-27.68c-5.38,0-10.43-2.07-14.61-6.01l-2.7-2.54v7.71c0,17,11.92,30.82,26.56,30.82h18.44s0,54.89,0,54.89c0,38.65-15.03,50.06-15.03,50.06h109.71c85.62,0,139.64-36.96,155.38-104.98h32.46c5.38,0,10.43,2.07,14.61,6l2.7,2.54v-7.71c0-17-11.92-30.83-26.56-30.83h-18.9c.32-4.88.49-9.87.49-15s-.18-10.11-.51-14.99h28.17c5.37,0,10.43,2.07,14.61,6.01ZM89.96,15.01h45.86c61.7,0,97.44,27.33,108.1,89.94l-153.96.02V15.01ZM136.21,284.93h-46.26v-89.98l153.87-.02c-9.97,56.66-42.07,88.38-107.61,90ZM247.34,149.96c0,5.13-.11,10.13-.34,14.99l-157.04.02v-29.99l157.05-.02c.22,4.84.33,9.83.33,15Z"></path>' +
    "</svg>";

  function dismissCollectionLoader() {
    document.body.classList.add("kartmax-collection-loader-dismissed");
    // remove early snippet loader
    const boot =
      document.getElementById("kartmax-app-boot-loader") ||
      document.getElementById("kartmax-search-boot-loader");
    if (boot) {
      boot.setAttribute("hidden", "hidden");
      boot.setAttribute("aria-busy", "false");
      boot.classList.add("is-leaving");
      if (boot.parentNode) {
        boot.remove();
      }
    }
  }

  // reuse search #ddd skeleton images for CLP loader
  function getThemeAssetUrl(fileName) {
    if (!fileName) {
      return "";
    }
    if (KARTMAX_THEME_ASSET_BASE) {
      return KARTMAX_THEME_ASSET_BASE + fileName;
    }
    const nodes = document.querySelectorAll(
      'link[href*="/assets/"], script[src*="/assets/"], img[src*="/assets/"]',
    );
    for (let i = 0; i < nodes.length; i += 1) {
      const href = nodes[i].href || nodes[i].src || "";
      const idx = href.indexOf("/assets/");
      if (idx === -1) {
        continue;
      }
      return href.slice(0, idx + "/assets/".length) + fileName;
    }
    return "/" + fileName;
  }

  function buildSkeletonLoaderHtml(label) {
    const desktop = getThemeAssetUrl("kartmax-loader-search-desktop-skeleton.png");
    const mobile = getThemeAssetUrl("kartmax-loader-search-mobile-skeleton.png");
    const text = label || "Loading products…";
    return (
      '<div class="kartmax-skeleton-loader" data-kartmax-skeleton-loader>' +
      "  <picture>" +
      '    <source media="(max-width: 989px)" srcset="' +
      mobile +
      '">' +
      '    <img class="kartmax-skeleton-loader__img" src="' +
      desktop +
      '" alt="" width="1400" height="900" decoding="async">' +
      "  </picture>" +
      '  <span class="kartmax-search-visually-hidden">' +
      text +
      "</span>" +
      "</div>"
    );
  }

  // always use skeleton (app host may still have old spinner)
  function ensureCollectionSkeletonLoader(loaderNode, label) {
    if (!loaderNode) {
      return;
    }
    if (!loaderNode.querySelector("[data-kartmax-skeleton-loader]")) {
      loaderNode.innerHTML = buildSkeletonLoaderHtml(label || "Loading products…");
    }
    loaderNode.hidden = false;
    loaderNode.setAttribute("aria-busy", "true");
  }

  function readCollectionConfig() {
    const host = document.querySelector(
      "#" + CONTAINER_ID + "[data-kartmax-collection-host], .kartmax-collection-page[data-kartmax-collection-host]",
    );
    const localNode =
      host && host.querySelector("[data-kartmax-collection-config]");
    const configNode = localNode || document.querySelector(CONFIG_SELECTOR);
    if (!configNode || !configNode.textContent) {
      return null;
    }

    try {
      return JSON.parse(configNode.textContent);
    } catch (error) {
      console.error("KartmaX collection config is invalid.", error);
      return null;
    }
  }

  function startCollectionRuntime(config, container) {
    applyUiTheme(container, config);
    hideNativeCollectionUi(config.hideSelector, container);
    bindFiltersChrome(config, container);

    const runtime = {
      expandedFacetKey: "",
      facetFilters: [],
      apiSortOptions: [],
      pending: createPendingFromState({
        activeFilters: parseActiveFilters(config.collectionFilter || ""),
        fieldspecials: resolveFieldspecials(config),
        page: 1,
        sortBy: "",
        sortDir: "desc",
      }),
    };

    const state = {
      activeFilters: parseActiveFilters(config.collectionFilter || ""),
      fieldspecials: resolveFieldspecials(config),
      page: 1,
      sortBy: "",
      sortDir: "desc",
    };

    loadCollectionPage(config, container, state, runtime);

    const sidebar = container.querySelector("[data-kartmax-filters-sidebar]");
    if (sidebar && window.matchMedia("(min-width: 990px)").matches) {
      sidebar.setAttribute("aria-hidden", "false");
    }
  }

  function removeCollectionHeroBanner(container) {
    if (!container) {
      return;
    }
    container.querySelectorAll(".kartmax-collection-page__hero").forEach(function (node) {
      node.remove();
    });
  }

  function hydrateCollectionHost(container, config) {
    // App host may still ship hero markup — strip it (theme CLP owns no banner).
    removeCollectionHeroBanner(container);
    // replace app spinner with skeleton before runtime
    ensureCollectionSkeletonLoader(
      container.querySelector("[data-kartmax-loader]"),
      "Loading products…",
    );
    startCollectionRuntime(config, container);
  }

  function bootstrap() {
    const rawConfig = readCollectionConfig();
    if (!rawConfig) {
      // No KartmaX collection config — restore native theme collection UI.
      dismissCollectionLoader();
      return;
    }

    if (!rawConfig.enabled) {
      dismissCollectionLoader();
      return;
    }

    initializeCollectionPlp(normalizeConfig(rawConfig));
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootstrap, { once: true });
  } else {
    bootstrap();
  }

  function normalizeConfig(raw) {
    const ui = raw.ui || {};

    return {
      collectionFilter: raw.collectionFilter || "",
      collectionDescription: raw.collectionDescription || "",
      collectionHandle: raw.collectionHandle || "",
      collectionTitle: raw.collectionTitle || "Collection",
      collectionFieldspecials: raw.collectionFieldspecials || "",
      hideSelector:
        raw.hideSelector ||
        "#product-grid, #ProductGridContainer, #main-collection-filters, .product-grid, .collection .product-grid, .product-grid-container, [data-collection-products], .collection-product-list, .facets-wrapper, .facets-vertical, .facets-vertical-sort, facet-filters-form, .product-count-vertical, .product-count-horizontal, .pagination, .pagination-wrapper, .collection-hero, .collection-banner, .main-collection-banner, .collection__title, .collection-hero__title",
      collectionId: raw.collectionId || "",
      pageSize: Number(raw.pageSize) || 24,
      plpApiUrl: raw.plpApiUrl || "",
      replaceCollectionPage:
        typeof raw.replaceCollectionPage === "boolean"
          ? raw.replaceCollectionPage
          : true,
      ui: {
        accentColor: ui.accentColor || "#0053a3",
        applyFiltersLabel: ui.applyFiltersLabel || "Apply The Filters",
        clearFiltersLabel: ui.clearFiltersLabel || "Clear",
        drawerTitle: ui.drawerTitle || "Sort & Filter",
        drawerWidth: ui.drawerWidth || "40rem",
        filterButtonLabel: ui.filterButtonLabel || "Sort & Filter",
        showFilterButton: ui.showFilterButton !== false,
        sortByLabel: ui.sortByLabel || "Sort By",
      },
    };
  }

  function initializeCollectionPlp(config) {
    if (!config.replaceCollectionPage) {
      dismissCollectionLoader();
      return;
    }

    const existingHost = document.querySelector(
      "#" + CONTAINER_ID + "[data-kartmax-collection-host], .kartmax-collection-page[data-kartmax-collection-host]",
    );
    if (existingHost) {
      // Theme section / pasted host already rendered with a loader — hydrate it.
      if (existingHost.dataset.kartmaxCollectionHydrated === "true") {
        dismissCollectionLoader();
        return;
      }
      existingHost.dataset.kartmaxCollectionHydrated = "true";
      hydrateCollectionHost(existingHost, config);
      return;
    }

    if (document.getElementById(CONTAINER_ID) || document.querySelector(".kartmax-collection-page")) {
      dismissCollectionLoader();
      return;
    }

    const mountTarget = resolveMountTarget();
    if (!mountTarget) {
      dismissCollectionLoader();
      return;
    }

    const container = document.createElement("section");
    container.id = CONTAINER_ID;
    container.className = "kartmax-collection-page";
    container.setAttribute("data-kartmax-collection-page", "true");
    // no collection hero/banner in Kartmax CLP
    container.innerHTML =
      '<div class="kartmax-collection-page__mobile-bar" data-kartmax-mobile-bar hidden></div>' +
      '<div class="kartmax-collection-page__layout">' +
      '  <aside class="kartmax-collection-page__sidebar" data-kartmax-filters-sidebar aria-label="Filter and sort" aria-hidden="true">' +
      '    <div class="kartmax-collection-page__sidebar-inner">' +
      '      <h2 class="kartmax-collection-page__sidebar-title" data-kartmax-drawer-title>Sort &amp; Filter</h2>' +
      '      <div class="kartmax-collection-page__sidebar-header">' +
      '        <h2 class="kartmax-collection-page__sidebar-mobile-title">Sort &amp; Filter</h2>' +
      '        <button type="button" class="kartmax-collection-page__sidebar-close" data-kartmax-filters-close aria-label="Close filters">&times;</button>' +
      "      </div>" +
      '      <div class="kartmax-collection-page__sidebar-sort" data-kartmax-sidebar-sort></div>' +
      '      <div class="kartmax-collection-page__sidebar-facets" data-kartmax-sidebar-filters></div>' +
      '      <div class="kartmax-collection-page__sidebar-footer">' +
      '        <button type="button" class="kartmax-collection-page__filter-apply" data-kartmax-filter-apply>Apply The Filters</button>' +
      '        <button type="button" class="kartmax-collection-page__filter-clear" data-kartmax-filter-clear hidden>Clear All Filters</button>' +
      "      </div>" +
      "    </div>" +
      "  </aside>" +
      '  <div class="kartmax-collection-page__main">' +
      '    <p class="kartmax-collection-page__summary" data-kartmax-summary>Loading products…</p>' +
      '    <div class="kartmax-collection-page__loader" data-kartmax-loader role="status" aria-live="polite">' +
      buildSkeletonLoaderHtml("Loading products…") +
      "</div>" +
      '    <div class="kartmax-collection-page__grid" data-kartmax-grid></div>' +
      '    <nav class="kartmax-collection-page__pagination" data-kartmax-pagination aria-label="Collection pagination"></nav>' +
      "  </div>" +
      "</div>" +
      '<button type="button" class="kartmax-collection-page__mobile-backdrop" data-kartmax-filters-backdrop hidden aria-label="Close filters"></button>';

    const mountTargetExistingChildren =
      mountTarget === document.body ? [] : Array.from(mountTarget.children);

    mountTarget.insertAdjacentElement("afterbegin", container);
    hideMountTargetSiblings(mountTargetExistingChildren);
    startCollectionRuntime(config, container);
  }

  function applyUiTheme(container, config) {
    const ui = config.ui || {};
    container.style.setProperty("--kmx-plp-accent", ui.accentColor || "#1e4b9b");
    container.style.setProperty("--kmx-plp-accent-border", ui.accentColor || "#1e4b9b");
    container.style.setProperty("--kmx-plp-button-text", ui.accentColor || "#1e4b9b");
    container.style.setProperty("--kmx-plp-drawer-width", ui.drawerWidth || "40rem");
  }

  function createPendingFromState(state) {
    return {
      activeFilters: state.activeFilters.slice(),
      sortBy: state.sortBy || "",
      sortDir: state.sortDir || "desc",
    };
  }

  function parseActiveFilters(filterValue) {
    const normalized = (filterValue || "").trim();
    if (!normalized) {
      return [];
    }

    return normalized.split("|").map(function (part) {
      return part.trim();
    }).filter(Boolean);
  }

  // KartmaX PLP accepts one `filter` param; multiple selections are pipe-joined
  // (e.g. brand~A|brand~B). Comma/semicolon and repeated filter params did not work.
  function combineFiltersForApi(filters) {
    return (filters || []).filter(Boolean).join("|");
  }

  // sticky sidebar top = live header bottom (PLP)
  function syncStickySidebarOffset(container) {
    function measureHeaderBottom() {
      let bottom = 0;
      const nodes = document.querySelectorAll(
        "site-header-wrapper, .site-header-wrapper, #shopify-section-header, .announcement-bar, .top-bar, .usp-bar, [id*='announcement']"
      );
      nodes.forEach(function (node) {
        const rect = node.getBoundingClientRect();
        if (rect.width < 1 || rect.height < 1) {
          return;
        }
        const style = window.getComputedStyle(node);
        const isPinned = style.position === "fixed" || style.position === "sticky";
        if ((rect.top <= 1 || (isPinned && rect.top < 100)) && rect.bottom > bottom) {
          bottom = rect.bottom;
        }
      });
      const wrap = document.querySelector("site-header-wrapper, .site-header-wrapper");
      if (wrap) {
        const rect = wrap.getBoundingClientRect();
        if (rect.bottom > bottom) {
          bottom = rect.bottom;
        }
      }
      return Math.max(Math.ceil(bottom + 12), 96);
    }

    function update() {
      const sidebar = container.querySelector("[data-kartmax-filters-sidebar]");
      if (!sidebar) {
        return;
      }
      if (!window.matchMedia("(min-width: 990px)").matches) {
        sidebar.style.removeProperty("top");
        sidebar.style.removeProperty("max-height");
        container.style.removeProperty("--kmx-sticky-offset");
        return;
      }
      const offsetPx = measureHeaderBottom();
      const offset = offsetPx + "px";
      container.style.setProperty("--kmx-sticky-offset", offset);
      sidebar.style.position = "sticky";
      sidebar.style.alignSelf = "start";
      sidebar.style.top = offset;
      sidebar.style.maxHeight = "calc(100vh - " + offset + " - 0.75rem)";
      sidebar.style.overflowX = "hidden";
      sidebar.style.overflowY = "auto";
    }

    if (container.dataset.kmxStickyBound === "true") {
      update();
      return;
    }
    container.dataset.kmxStickyBound = "true";
    update();
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    if (typeof ResizeObserver !== "undefined") {
      const wrap = document.querySelector("site-header-wrapper, .site-header-wrapper");
      if (wrap) {
        new ResizeObserver(update).observe(wrap);
      }
    }
  }

  function bindFiltersChrome(config, container) {
    const titleNode = container.querySelector("[data-kartmax-drawer-title]");
    const applyButton = container.querySelector("[data-kartmax-filter-apply]");
    const clearButton = container.querySelector("[data-kartmax-filter-clear]");

    if (titleNode) {
      titleNode.textContent = config.ui.drawerTitle || "Sort & Filter";
    }
    const mobileTitle = container.querySelector(".kartmax-collection-page__sidebar-mobile-title");
    if (mobileTitle) {
      mobileTitle.textContent = config.ui.drawerTitle || "Sort & Filter";
    }

    if (applyButton) {
      applyButton.textContent = config.ui.applyFiltersLabel;
    }

    if (clearButton) {
      clearButton.textContent = config.ui.clearFiltersLabel;
    }

    // Apply button mobile-only (collection)
    function syncApplyFilterVisibility() {
      const btn = container.querySelector("[data-kartmax-filter-apply]");
      if (!btn) {
        return;
      }
      const isMobile = window.matchMedia("(max-width: 989px)").matches;
      btn.hidden = !isMobile;
      btn.style.setProperty("display", isMobile ? "block" : "none", "important");
    }
    syncApplyFilterVisibility();
    if (!container.dataset.kmxApplyVisibilityBound) {
      container.dataset.kmxApplyVisibilityBound = "true";
      window.addEventListener("resize", syncApplyFilterVisibility);
    }

    const sidebar = container.querySelector("[data-kartmax-filters-sidebar]");
    if (sidebar && window.matchMedia("(min-width: 990px)").matches) {
      sidebar.setAttribute("aria-hidden", "false");
    }

    syncStickySidebarOffset(container);

    container.querySelectorAll("[data-kartmax-filters-close], [data-kartmax-filters-backdrop]").forEach(function (node) {
      node.addEventListener("click", function () {
        closeMobileFilters(container);
      });
    });

    document.addEventListener("keydown", function (event) {
      const sidebar = container.querySelector("[data-kartmax-filters-sidebar]");
      if (event.key === "Escape" && sidebar && sidebar.classList.contains("is-mobile-open")) {
        closeMobileFilters(container);
      }
    });
  }

  function openMobileFilters(container, facetKey) {
    const sidebar = container.querySelector("[data-kartmax-filters-sidebar]");
    const backdrop = container.querySelector("[data-kartmax-filters-backdrop]");
    if (!sidebar) {
      return;
    }

    sidebar.classList.add("is-mobile-open");
    sidebar.setAttribute("aria-hidden", "false");
    if (backdrop) {
      backdrop.hidden = false;
    }
    document.body.classList.add("kartmax-collection-drawer-open");

    if (facetKey) {
      expandFacet(container, facetKey);
      const toggle = sidebar.querySelector(
        '[data-kartmax-facet-toggle][data-facet-key="' + facetKey + '"]',
      );
      if (toggle) {
        window.requestAnimationFrame(function () {
          toggle.scrollIntoView({ block: "nearest" });
        });
      }
    }
  }

  function closeMobileFilters(container) {
    const sidebar = container.querySelector("[data-kartmax-filters-sidebar]");
    const backdrop = container.querySelector("[data-kartmax-filters-backdrop]");
    if (!sidebar) {
      return;
    }

    sidebar.classList.remove("is-mobile-open");
    if (window.matchMedia("(max-width: 989px)").matches) {
      sidebar.setAttribute("aria-hidden", "true");
    } else {
      sidebar.setAttribute("aria-hidden", "false");
    }
    if (backdrop) {
      backdrop.hidden = true;
    }
    document.body.classList.remove("kartmax-collection-drawer-open");
  }

  // allow empty key to collapse all facets.
  function expandFacet(container, facetKey) {
    const sidebar = container.querySelector("[data-kartmax-filters-sidebar]");
    if (!sidebar) {
      return;
    }

    sidebar.querySelectorAll("[data-kartmax-facet]").forEach(function (facetNode) {
      const isTarget =
        !!facetKey && facetNode.getAttribute("data-facet-key") === facetKey;
      facetNode.classList.toggle("is-expanded", isTarget);
      const body = facetNode.querySelector("[data-kartmax-facet-body]");
      const toggle = facetNode.querySelector("[data-kartmax-facet-toggle]");
      if (body) {
        body.hidden = !isTarget;
      }
      if (toggle) {
        toggle.setAttribute("aria-expanded", isTarget ? "true" : "false");
      }
    });
  }

  function resolveMountTarget() {
    const selectors = [
      ".template-collection",
      ".collection",
      "main#MainContent",
      "main",
    ];

    for (const selector of selectors) {
      const match = document.querySelector(selector);
      if (match) {
        return match;
      }
    }

    return document.body;
  }

  function resolveFieldspecials(config) {
    if (config.collectionFieldspecials) {
      return config.collectionFieldspecials;
    }

    const handle = (config.collectionHandle || "").trim();
    if (!handle || handle === "all") {
      return "";
    }

    return "_uuid~" + handle + "|overall_stock_status~in-stock";
  }

  function hideMountTargetSiblings(existingChildren) {
    existingChildren.forEach(function (node) {
      if (!(node instanceof Element)) {
        return;
      }

      node.classList.add(HIDDEN_CLASS);
      node.setAttribute("aria-hidden", "true");
    });
  }

  function hideNativeCollectionUi(selectorText, preservedNode) {
    const selectors = selectorText
      .split(",")
      .map(function (item) {
        return item.trim();
      })
      .filter(Boolean);

    NATIVE_COLLECTION_BANNER_SELECTORS.forEach(function (selector) {
      if (selectors.indexOf(selector) === -1) {
        selectors.push(selector);
      }
    });

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (node) {
        if (
          preservedNode &&
          (node === preservedNode || preservedNode.contains(node) || node.contains(preservedNode))
        ) {
          return;
        }

        if (node.closest(".kartmax-collection-page, #" + CONTAINER_ID)) {
          return;
        }

        node.classList.add(HIDDEN_CLASS);
        node.setAttribute("aria-hidden", "true");
      });
    });
  }

  function loadCollectionPage(config, container, state, runtime, options) {
    const summaryNode = container.querySelector("[data-kartmax-summary]");
    const gridNode = container.querySelector("[data-kartmax-grid]");
    const paginationNode = container.querySelector("[data-kartmax-pagination]");
    const loaderNode = container.querySelector("[data-kartmax-loader]");
    const appendProducts = Boolean(options && options.appendProducts);
    const requestId = (runtime.requestId || 0) + 1;
    runtime.requestId = requestId;

    if (!summaryNode || !gridNode) {
      return;
    }

    if (!appendProducts) {
      summaryNode.textContent = "Loading products…";
      gridNode.innerHTML = "";
      // same skeleton as search (filter/sort reloads too)
      ensureCollectionSkeletonLoader(loaderNode, "Loading products…");
    }

    const plpUrl = buildPlpUrl(config, state);
    if (!plpUrl) {
      summaryNode.textContent =
        "KartmaX is not configured. Save KartmaX settings in the app admin.";
      gridNode.innerHTML =
        '<p class="kartmax-collection-page__empty">KartmaX is not configured. Save KartmaX settings in the app admin.</p>';
      if (loaderNode) {
        loaderNode.hidden = true;
      }
      dismissCollectionLoader();
      return;
    }

    fetch(plpUrl)
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Collection PLP request failed.");
        }

        return response.json();
      })
      .then(function (payload) {
        if (requestId !== runtime.requestId) {
          return;
        }

        const result = payload.result || {};
        const products = Array.isArray(result.products) ? result.products : [];
        const total = Number(result.count || payload.totalHits || products.length || 0);
        const pageSize = config.pageSize;
        const totalPages = Math.max(1, Math.ceil(total / pageSize));
        const responseFacetFilters = getFacetFilters(result.filters || []);

        // Facets come straight from the plp-special API response:
        // - Selecting a filter  → API returns the filtered facet set → render it.
        // - Clear All           → API returns the full facet set → render it.
        // - Load More (page 2+) → API returns filters: [] → keep the current
        //   sidebar as is, so the applied filters stay visible.
        // - A filtered result that returns no facets is treated the same way,
        //   so the user can still undo the selection.
        if (responseFacetFilters.length) {
          runtime.apiFilters = result.filters || [];
          runtime.facetFilters = retainSelectedOptions(
            responseFacetFilters,
            runtime.facetFilters,
            state.activeFilters,
          );
        }

        // dynamic sort comes back as a *top-level*
        // `result.sort` array (e.g. [{code, label, dir}]), not embedded inside
        // `result.filters`. Keep the last non-empty list across pages, since
        // some pages omit it the same way facet `filters` can be omitted.
        if (Array.isArray(result.sort) && result.sort.length) {
          runtime.apiSortOptions = result.sort;
        } else if (!Array.isArray(runtime.apiSortOptions)) {
          runtime.apiSortOptions = [];
        }

        runtime.pending = createPendingFromState(state);

        renderMobileFilterBar(config, container, state, runtime, runtime.facetFilters);
        renderFiltersPanel(config, container, state, runtime, function (nextState) {
          loadCollectionPage(config, container, nextState, runtime);
        });
        renderProducts(gridNode, products, config, appendProducts);
        // bind search tracking before the cart handler,
        // so product_click / add_to_cart listeners always run first.
        bindGridEventTracking(gridNode);
        bindProductCardActions(gridNode);
        const shownProducts = Math.min(
          total,
          gridNode.querySelectorAll(".kartmax-collection-page__card").length,
        );
        renderLoadMore(paginationNode, state, totalPages, shownProducts, total, function (nextPage) {
          loadCollectionPage(config, container, {
            ...state,
            page: nextPage,
          }, runtime, { appendProducts: true });
        });

        summaryNode.textContent = formatResultsSummary(total, shownProducts);
        if (loaderNode) {
          loaderNode.hidden = true;
        }
        dismissCollectionLoader();
      })
      .catch(function () {
        if (requestId !== runtime.requestId) {
          return;
        }

        if (appendProducts) {
          summaryNode.textContent = "Could not load more products. Please try again.";
          const loadMoreButton = paginationNode && paginationNode.querySelector("[data-page]");
          if (loadMoreButton) {
            loadMoreButton.disabled = false;
            loadMoreButton.removeAttribute("aria-busy");
            loadMoreButton.textContent = "Load More";
          }
          return;
        }

        summaryNode.textContent =
          "KartmaX collection results are temporarily unavailable.";
        gridNode.innerHTML =
          '<p class="kartmax-collection-page__empty">Please try again in a moment.</p>';
        renderMobileFilterBar(config, container, state, runtime, []);
        if (paginationNode) {
          paginationNode.innerHTML = "";
        }
        if (loaderNode) {
          loaderNode.hidden = true;
        }
        dismissCollectionLoader();
      });
  }

  function isAbsoluteUrl(value) {
    return /^https?:\/\//i.test(value || "");
  }

  // search_id / session_id for the plp call, only
  // when the collection URL has ?q=. Uses the shared attribution module so the
  // listing call and the product_click / add_to_cart events always carry the
  // same, query-matched ids. The fallback applies the same query check when
  // the attribution script is not loaded.
  function getSearchTrackingParams() {
    let searchKeyword = "";
    try {
      searchKeyword = (new URL(window.location.href).searchParams.get("q") || "").trim();
    } catch (error) {
      searchKeyword = "";
    }

    if (!searchKeyword || searchKeyword === "*") {
      return { searchId: "", sessionId: "" };
    }

    if (
      window.KartmaxSearchAttribution &&
      typeof window.KartmaxSearchAttribution.readSearchAttribution === "function"
    ) {
      const attribution = window.KartmaxSearchAttribution.readSearchAttribution() || {};
      return {
        searchId: attribution.searchId || "",
        sessionId: attribution.sessionId || "",
      };
    }

    function normalizeQuery(value) {
      const text = String(value || "").trim().toLowerCase();
      return text === "*" ? "" : text;
    }

    function readStorageValue(storage, key) {
      try {
        return String(storage.getItem(key) || "").trim();
      } catch (error) {
        return "";
      }
    }

    const currentQuery = normalizeQuery(searchKeyword);

    let cached = {};
    try {
      cached =
        JSON.parse(
          readStorageValue(window.sessionStorage, "kartmax:search-page-tracking") || "{}",
        ) || {};
    } catch (error) {
      cached = {};
    }
    const cachedMatchesQuery = normalizeQuery(cached.query) === currentQuery;

    const widgetSearchId = readStorageValue(
      window.localStorage,
      "km-search-widget:current-query-id",
    );
    const widgetQueryText = readStorageValue(
      window.localStorage,
      "km-search-widget:current-query-text",
    );
    const widgetSessionId = readStorageValue(
      window.localStorage,
      "km-search-widget:tracking-session-id",
    );
    const widgetMatchesQuery = normalizeQuery(widgetQueryText) === currentQuery;

    return {
      searchId:
        (cachedMatchesQuery && String(cached.searchId || "").trim()) ||
        (widgetMatchesQuery && widgetSearchId) ||
        "",
      sessionId: widgetSessionId || String(cached.sessionId || "").trim() || "",
    };
  }

  function buildPlpUrl(config, state) {
    if (!config.plpApiUrl) {
      return null;
    }

    const url = isAbsoluteUrl(config.plpApiUrl)
      ? new URL(config.plpApiUrl)
      : new URL(config.plpApiUrl, window.location.origin);
    url.searchParams.set("collection", config.collectionId || "");
    url.searchParams.set("page", String(state.page || 1));
    url.searchParams.set("count", String(config.pageSize));

    if (state.fieldspecials) {
      url.searchParams.set("fieldspecials", state.fieldspecials);
    }

    const combinedFilter = combineFiltersForApi(state.activeFilters);
    if (combinedFilter) {
      url.searchParams.set("filter", combinedFilter);
    }

    if (state.sortBy) {
      url.searchParams.set("sort_by", state.sortBy);
      url.searchParams.set("sort_dir", state.sortDir === "asc" ? "asc" : "desc");
    }

    // Send search tracking only when the collection URL contains ?q=search_keyword.
    const tracking = getSearchTrackingParams();

    if (tracking.searchId) {
      url.searchParams.set("search_id", tracking.searchId);
    }

    if (tracking.sessionId) {
      url.searchParams.set("session_id", tracking.sessionId);
    }

    return url.toString();
  }

  function isSortOnlyFilter(filter) {
    const code = (filter.code || "").toLowerCase();
    const label = (filter.filter_lable || "").toLowerCase();
    return code === "sort" || code === "sort_by" || code === "_sort" || /^sort\b/.test(label);
  }

  function coerceFilterOptions(options) {
    if (Array.isArray(options)) {
      return options;
    }

    if (options && typeof options === "object") {
      return Object.values(options);
    }

    return [];
  }

  function normalizeFacetOption(option) {
    const normalized = { ...(option || {}) };
    if (normalized.count == null && normalized.itemcount != null) {
      normalized.count = normalized.itemcount;
    }
    return normalized;
  }

  function getFacetFilters(filters) {
    return (filters || []).filter(function (filter) {
      return (
        !isSortOnlyFilter(filter) &&
        coerceFilterOptions(filter.options).length
      );
    }).map(function (filter) {
      return normalizeFacetOptions(filter);
    });
  }

  function isPriceFacet(filter) {
    return /price/i.test(
      String((filter && filter.code) || "") +
      " " +
      String((filter && filter.filter_lable) || ""),
    );
  }

  function getPriceOptionSortValue(option) {
    const text = String((option && (option.value || option.value_key)) || "")
      .replace(/,/g, "");
    const match = text.match(/\d+(?:\.\d+)?/);
    return match ? Number(match[0]) : Number.POSITIVE_INFINITY;
  }

  function normalizeFacetOptions(filter, options) {
    const normalizedOptions = coerceFilterOptions(options || filter.options).map(
      normalizeFacetOption,
    );
    if (isPriceFacet(filter)) {
      normalizedOptions.sort(function (left, right) {
        return getPriceOptionSortValue(left) - getPriceOptionSortValue(right);
      });
    }
    return {
      ...filter,
      options: normalizedOptions,
    };
  }

  function findFacetByKey(filters, key) {
    return (filters || []).find(function (filter) {
      return getFacetLabelKey(filter) === key;
    });
  }

  function findSelectedOption(filters, value) {
    const list = Array.isArray(filters) ? filters : [];
    for (let i = 0; i < list.length; i += 1) {
      const options = coerceFilterOptions(list[i].options);
      for (let j = 0; j < options.length; j += 1) {
        if (buildFilterValue(options[j]) === value) {
          return { filter: list[i], option: options[j] };
        }
      }
    }
    return null;
  }

  // Safety net: the API response is rendered as-is, except that a currently
  // selected option missing from the response is re-inserted under its facet
  // (without a count) so the user can still uncheck it.
  function retainSelectedOptions(responseFilters, previousFilters, activeFilters) {
    const selected = (activeFilters || []).filter(Boolean);
    if (!selected.length) {
      return responseFilters;
    }

    const filters = responseFilters.map(function (filter) {
      return { ...filter, options: coerceFilterOptions(filter.options).slice() };
    });

    const present = new Set();
    filters.forEach(function (filter) {
      filter.options.forEach(function (option) {
        const value = buildFilterValue(option);
        if (value) {
          present.add(value);
        }
      });
    });

    selected.forEach(function (value) {
      if (present.has(value)) {
        return;
      }

      const source = findSelectedOption(previousFilters, value);
      if (!source) {
        return;
      }

      let target = findFacetByKey(filters, getFacetLabelKey(source.filter));
      if (!target) {
        target = { ...source.filter, options: [] };
        filters.push(target);
      }

      const preserved = normalizeFacetOption(source.option);
      delete preserved.count;
      delete preserved.itemcount;
      delete preserved.doc_count;
      delete preserved.product_count;

      target.options.push(preserved);
      present.add(value);
    });

    return filters.map(function (filter) {
      return normalizeFacetOptions(filter);
    });
  }

  // dynamic sort options now come from the API's
  // top-level `result.sort` array: [{ code, label, dir }, ...]. Each entry is
  // turned into a "code:dir" value so it flows straight through
  // parseSortValue()/getSortValue()/buildPlpUrl() unchanged.
  //
  // `filters` is kept only as a fallback for older/alternate responses that
  // still embed a sort-like entry inside `result.filters`.
  function getSortOptions(sortDefs, filters) {
    const list = Array.isArray(sortDefs) ? sortDefs : [];

    if (list.length) {
      return [
        { value: "", label: "Featured" },
      ].concat(
        list.map(function (item) {
          const code = item.code || item.value_key || "";
          const dir =
            String(item.dir || item.direction || "desc").toLowerCase() === "asc"
              ? "asc"
              : "desc";
          return {
            value: code ? code + ":" + dir : "",
            label: item.label || item.filter_lable || item.value || code || "Sort option",
          };
        }),
      );
    }

    // Fallback: sort embedded inside `filters` (legacy/alternate shape).
    const sortFilter = (filters || []).find(function (filter) {
      return isSortOnlyFilter(filter);
    });

    if (sortFilter && Array.isArray(sortFilter.options) && sortFilter.options.length) {
      return [
        { value: "", label: "Featured" },
      ].concat(
        sortFilter.options.map(function (option) {
          return {
            value: option.value_key || "",
            label: option.value || option.value_key || "Sort option",
          };
        }),
      );
    }

    return DEFAULT_SORT_OPTIONS.slice();
  }

  function getSortValue(state) {
    if (!state.sortBy) {
      return "";
    }

    return state.sortBy + ":" + (state.sortDir === "asc" ? "asc" : "desc");
  }

  function parseSortValue(value) {
    if (!value) {
      return { sortBy: "", sortDir: "desc" };
    }

    const parts = value.split(":");
    return {
      sortBy: parts[0] || "",
      sortDir: parts[1] === "asc" ? "asc" : "desc",
    };
  }

  function getSortLabel(sortOptions, state) {
    const currentValue = getSortValue(state);
    const match = sortOptions.find(function (option) {
      return option.value === currentValue;
    });

    return match ? match.label : "Featured";
  }

  function getFacetLabelKey(filter) {
    return (filter.code || filter.filter_lable || "filter").toLowerCase();
  }

  function isSaleFacet(filter) {
    return /sale/i.test(filter.filter_lable || filter.code || "");
  }

  function renderSidebarSort(config, container, state, runtime, onChange) {
    const node = container.querySelector("[data-kartmax-sidebar-sort]");
    if (!node) {
      return;
    }

    const sortOptions = getSortOptions(runtime.apiSortOptions, runtime.apiFilters || []);
    const currentLabel = getSortLabel(sortOptions, state);
    const listId = "kartmax-sidebar-sort-list-" + CONTAINER_ID;

    node.innerHTML =
      '<div class="kartmax-collection-page__sidebar-sort-box">' +
       '<span class="kartmax-collection-page__sidebar-sort-prefix">Sort by :</span>' +
      '<button type="button" class="kartmax-collection-page__sidebar-sort-trigger" data-kartmax-sort-trigger aria-haspopup="listbox" aria-expanded="false" aria-controls="' +
      listId +
      '">' +

      '<span class="kartmax-collection-page__sidebar-sort-value">' +
      escapeHtml(currentLabel) +
      "</span>" +
      '<span class="kartmax-collection-page__sidebar-sort-chevron" aria-hidden="true"></span>' +
      "</button>" +
      '<ul class="kartmax-collection-page__sidebar-sort-list" id="' +
      listId +
      '" role="listbox" hidden data-kartmax-sort-list>' +
      sortOptions
        .map(function (option) {
          const selected = option.value === getSortValue(state) ? " is-selected" : "";
          return (
            '<li role="option" aria-selected="' +
            (selected ? "true" : "false") +
            '">' +
            '<button type="button" class="kartmax-collection-page__sidebar-sort-option' +
            selected +
            '" data-sort-value="' +
            escapeAttribute(option.value) +
            '">' +
            escapeHtml(option.label) +
            "</button>" +
            "</li>"
          );
        })
        .join("") +
      "</ul>" +
      "</div>";

    const trigger = node.querySelector("[data-kartmax-sort-trigger]");
    const list = node.querySelector("[data-kartmax-sort-list]");

    if (!trigger || !list) {
      return;
    }

    function closeList() {
      list.hidden = true;
      trigger.setAttribute("aria-expanded", "false");
      node.classList.remove("is-open");
    }

    trigger.addEventListener("click", function (event) {
      event.stopPropagation();
      const willOpen = list.hidden;
      closeList();
      if (willOpen) {
        list.hidden = false;
        trigger.setAttribute("aria-expanded", "true");
        node.classList.add("is-open");
      }
    });

    list.querySelectorAll("[data-sort-value]").forEach(function (button) {
      button.addEventListener("click", function () {
        closeList();
        onChange(parseSortValue(button.getAttribute("data-sort-value") || ""));
      });
    });

    if (!node.dataset.sortBound) {
      node.dataset.sortBound = "true";
      document.addEventListener("click", function (event) {
        if (!node.contains(event.target)) {
          closeList();
        }
      });
    }
  }

  // mobile dock; tick on Filter when filters applied
  function renderMobileFilterBar(config, container, state, runtime, facetFilters) {
    const bar = container.querySelector("[data-kartmax-mobile-bar]");
    if (!bar) {
      return;
    }

    if (!config.ui.showFilterButton) {
      bar.hidden = true;
      bar.innerHTML = "";
      document.body.classList.remove("kartmax-mobile-dock-active");
      return;
    }

    const hasAppliedFilters =
      Array.isArray(state.activeFilters) && state.activeFilters.length > 0;
    const filterTickHtml = hasAppliedFilters
      ? '<span class="kartmax-collection-page__mobile-dock-tick" aria-hidden="true">✓</span>'
      : "";

    bar.hidden = false;
    bar.classList.add("kartmax-collection-page__mobile-bar--dock");
    document.body.classList.add("kartmax-mobile-dock-active");
    bar.innerHTML =
      '<button type="button" class="kartmax-collection-page__mobile-dock-btn kartmax-collection-page__mobile-dock-btn--filters' +
      (hasAppliedFilters ? " is-filtered" : "") +
      '" data-kartmax-mobile-open-filters>' +
      '<svg class="kartmax-collection-page__mobile-dock-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
      '<path stroke="currentColor" stroke-width="1.7" stroke-linecap="round" d="M4 7h16M4 12h16M4 17h16"/>' +
      '<circle cx="9" cy="7" r="1.7" fill="currentColor"/>' +
      '<circle cx="15" cy="12" r="1.7" fill="currentColor"/>' +
      '<circle cx="11" cy="17" r="1.7" fill="currentColor"/>' +
      "</svg>" +
      "<span>Filter</span>" +
      filterTickHtml +
      "</button>" +
      '<button type="button" class="kartmax-collection-page__mobile-dock-btn kartmax-collection-page__mobile-dock-btn--sort" data-kartmax-mobile-sort>' +
      "<span>Sort</span>" +
      '<span class="kartmax-collection-page__mobile-dock-chevron" aria-hidden="true"></span>' +
      "</button>";

    const openFiltersButton = bar.querySelector("[data-kartmax-mobile-open-filters]");
    if (openFiltersButton) {
      openFiltersButton.addEventListener("click", function () {
        const sidebar = container.querySelector("[data-kartmax-filters-sidebar]");
        if (sidebar && sidebar.classList.contains("is-mobile-open")) {
          closeMobileFilters(container);
          return;
        }
        openMobileFilters(container, "");
      });
    }

    const sortButton = bar.querySelector("[data-kartmax-mobile-sort]");
    if (sortButton) {
      sortButton.addEventListener("click", function () {
        openMobileFilters(container, "");
        const sortTrigger = container.querySelector("[data-kartmax-sort-trigger]");
        if (sortTrigger) {
          sortTrigger.click();
        }
      });
    }
  }

  // desktop auto-apply; mobile Apply; Clear only when filters on
  function isMobileFilterViewport() {
    return window.matchMedia("(max-width: 989px)").matches;
  }

  function syncClearFilterButton(container, pending) {
    const clearButton = container.querySelector("[data-kartmax-filter-clear]");
    if (!clearButton) {
      return;
    }
    const hasFilters =
      Array.isArray(pending && pending.activeFilters) &&
      pending.activeFilters.length > 0;
    clearButton.hidden = !hasFilters;
  }

  function renderFiltersPanel(config, container, state, runtime, onApply) {
    const filtersNode = container.querySelector("[data-kartmax-sidebar-filters]");
    const clearButton = container.querySelector("[data-kartmax-filter-clear]");
    const applyButton = container.querySelector("[data-kartmax-filter-apply]");
    if (!filtersNode || !clearButton) {
      return;
    }

    const pending = runtime.pending;
    const facetFilters = runtime.facetFilters || [];

    function commitFilters() {
      if (isMobileFilterViewport()) {
        closeMobileFilters(container);
      }
      onApply({
        ...state,
        activeFilters: pending.activeFilters.slice(),
        sortBy: pending.sortBy,
        sortDir: pending.sortDir,
        page: 1,
      });
      window.requestAnimationFrame(function () {
        scrollToCollectionResults(container);
      });
    }

    renderSidebarSort(config, container, state, runtime, function (nextSort) {
      pending.sortBy = nextSort.sortBy;
      pending.sortDir = nextSort.sortDir;
      commitFilters();
    });

    syncClearFilterButton(container, pending);

    if (!facetFilters.length) {
      filtersNode.innerHTML =
        '<p class="kartmax-collection-page__sidebar-empty">No filters available for this collection.</p>';
      clearButton.onclick = function () {
        pending.activeFilters = [];
        syncClearFilterButton(container, pending);
        commitFilters();
      };
      if (applyButton) {
        applyButton.onclick = function () {
          commitFilters();
        };
      }
      return;
    }

    filtersNode.innerHTML = facetFilters
      .map(function (filter) {
        const label = filter.filter_lable || filter.code || "Filter";
        const facetKey = getFacetLabelKey(filter);
        const isExpanded = runtime.expandedFacetKey === facetKey;
        const saleClass = isSaleFacet(filter) ? " kartmax-collection-page__facet--sale" : "";
        const options = (filter.options || [])
          .map(function (option) {
            const value = buildFilterValue(option);
            const checked = pending.activeFilters.indexOf(value) !== -1 ? " checked" : "";
            const count = option.count ?? option.doc_count ?? option.product_count;
            const countHtml = Number.isFinite(Number(count))
              ? '<span class="kartmax-collection-page__facet-option-count">(' +
                escapeHtml(String(count)) +
                ")</span>"
              : "";
            return (
              '<label class="kartmax-collection-page__facet-option">' +
              '<input type="checkbox" value="' +
              escapeAttribute(value) +
              '" data-kartmax-facet-input' +
              checked +
              ">" +
              '<span class="kartmax-collection-page__facet-option-label">' +
              escapeHtml(option.value || option.value_key || value) +
              "</span>" +
              countHtml +
              "</label>"
            );
          })
          .join("");

        return (
          '<div class="kartmax-collection-page__facet' +
          saleClass +
          (isExpanded ? " is-expanded" : "") +
          '" data-kartmax-facet data-facet-key="' +
          escapeAttribute(facetKey) +
          '">' +
          '<button type="button" class="kartmax-collection-page__facet-toggle" data-kartmax-facet-toggle data-facet-key="' +
          escapeAttribute(facetKey) +
          '" aria-expanded="' +
          (isExpanded ? "true" : "false") +
          '">' +
          '<span class="kartmax-collection-page__facet-label">' +
          escapeHtml(label) +
          "</span>" +
          '<span class="kartmax-collection-page__facet-chevron" aria-hidden="true"></span>' +
          "</button>" +
          '<div class="kartmax-collection-page__facet-body" data-kartmax-facet-body' +
          (isExpanded ? "" : " hidden") +
          ">" +
          options +
          "</div>" +
          "</div>"
        );
      })
      .join("");

    filtersNode.querySelectorAll("[data-kartmax-facet-toggle]").forEach(function (button) {
      button.addEventListener("click", function () {
        const facetKey = button.getAttribute("data-facet-key") || "";
        runtime.expandedFacetKey =
          runtime.expandedFacetKey === facetKey ? "" : facetKey;
        expandFacet(container, runtime.expandedFacetKey);
      });
    });

    filtersNode.querySelectorAll("[data-kartmax-facet-input]").forEach(function (input) {
      input.addEventListener("change", function () {
        const value = input.value || "";
        if (!value) {
          return;
        }

        if (input.checked) {
          if (pending.activeFilters.indexOf(value) === -1) {
            pending.activeFilters.push(value);
          }
        } else {
          pending.activeFilters = pending.activeFilters.filter(function (item) {
            return item !== value;
          });
        }

        syncClearFilterButton(container, pending);

        // Desktop: auto-apply. Mobile: wait for Apply button.
        if (!isMobileFilterViewport()) {
          commitFilters();
        }
      });
    });

    clearButton.onclick = function () {
      pending.activeFilters = [];
      syncClearFilterButton(container, pending);
      commitFilters();
    };

    if (applyButton) {
      applyButton.onclick = function () {
        commitFilters();
      };
    }
  }

  function readProductNumber(product, keys) {
    if (!product || typeof product !== "object") {
      return null;
    }

    for (let index = 0; index < keys.length; index += 1) {
      const value = Number(product[keys[index]]);
      if (Number.isFinite(value)) {
        return value;
      }
    }

    return null;
  }

  function resolveProductImageUrl(product) {
    if (
      window.KartmaxProductLinks &&
      typeof window.KartmaxProductLinks.resolveProductImage === "function"
    ) {
      const linkedImage = window.KartmaxProductLinks.resolveProductImage(product);
      if (linkedImage) {
        return linkedImage;
      }
    }

    return typeof product.image === "string" ? product.image : "";
  }

  function resolveProductHandle(product) {
    if (
      window.KartmaxProductLinks &&
      typeof window.KartmaxProductLinks.resolveProductHandle === "function"
    ) {
      return window.KartmaxProductLinks.resolveProductHandle(product);
    }

    return typeof product.url_key === "string" ? product.url_key : "";
  }

  function roundMoney(value) {
    return Math.round(Number(value) * 100) / 100;
  }

  // Shopify cents mixed with Kartmax AED major units (e.g. 6995 vs 49.95).
  function normalizePossiblyCents(value, peer) {
    if (!Number.isFinite(value) || value <= 0) {
      return value;
    }
    if (
      Number.isInteger(value) &&
      value >= 100 &&
      Number.isFinite(peer) &&
      peer > 0 &&
      value >= peer * 50
    ) {
      return roundMoney(value / 100);
    }
    return value;
  }

  function readOfferBadge(product) {
  if (!product || typeof product !== "object") {
    return "";
  }

  let offerInfo = product.meta_offer_information;

  // Handle metafield if it comes as a JSON string.
  if (typeof offerInfo === "string") {
    try {
      offerInfo = JSON.parse(offerInfo);
    } catch (error) {
      offerInfo = null;
    }
  }

  // 1. Primary source: meta_offer_information.badge
  if (
    offerInfo &&
    typeof offerInfo === "object" &&
    typeof offerInfo.badge === "string" &&
    offerInfo.badge.trim()
  ) {
    return offerInfo.badge.trim();
  }

  // 2. Existing product badge fallback
  if (
    typeof product.badge === "string" &&
    product.badge.trim()
  ) {
    return product.badge.trim();
  }

  // 3. Calculate discount from price and selling_price
  const price = readProductNumber(product, [
    "price",
    "price_min",
    "priceMin",
  ]);

  const sellingPrice = readProductNumber(product, [
    "selling_price",
    "sellingPrice",
    "special_price",
    "specialPrice",
    "discounted_price",
    "discountedPrice",
  ]);

  if (
    Number.isFinite(price) &&
    Number.isFinite(sellingPrice) &&
    price > sellingPrice &&
    sellingPrice > 0
  ) {
    const discountPercentage = Math.round(
      ((price - sellingPrice) / price) * 100
    );

    if (discountPercentage > 0) {
      return discountPercentage + "% OFF";
    }
  }

  return "";
}

  // Real prices only; RSP from `price` when `selling_price` exists (same as search page).
  function resolveProductPricing(product) {
    const dedicatedSalePrice = readProductNumber(product, [
      "selling_price",
      "sellingPrice",
      "special_price",
      "specialPrice",
      "discounted_price",
      "discountedPrice",
    ]);
    const fallbackPrice = readProductNumber(product, [
      "price",
      "price_min",
      "priceMin",
    ]);
    let salePrice = dedicatedSalePrice || fallbackPrice;

    const rspKeys = [
      "rsp",
      "rrp",
      "msrp",
      "compare_at_price",
      "compareAtPrice",
      "price_max",
      "highPrice",
      "regular_price",
      "regularPrice",
      "original_price",
      "originalPrice",
    ];
    // Kartmax: `price` is list/RSP when a dedicated selling/special price exists.
    if (dedicatedSalePrice) {
      rspKeys.push("price");
    }

    let rsp = readProductNumber(product, rspKeys);
    salePrice = normalizePossiblyCents(salePrice, rsp);
    rsp = normalizePossiblyCents(rsp, salePrice);

    if (!rsp || !salePrice || rsp <= salePrice) {
      rsp = null;
    }

    const savings =
      rsp && salePrice && rsp > salePrice ? roundMoney(rsp - salePrice) : null;

    return {
      salePrice: Number.isFinite(salePrice) ? roundMoney(salePrice) : null,
      rsp: Number.isFinite(rsp) ? roundMoney(rsp) : null,
      savings: savings,
      badge: readOfferBadge(product),
    };
  }

  function formatPriceNumber(value) {
    const amount = Number(value);
    if (!Number.isFinite(amount)) {
      return "";
    }
    return (Math.round(amount * 100) / 100).toFixed(2);
  }

  function renderMoneyWithDirham(value) {
    const amountText = formatPriceNumber(value);
    if (!amountText) {
      return "";
    }
    return DIRHAM_ICON_SVG + " " + amountText;
  }

  function renderProductPriceHtml(pricing) {
    if (!pricing || !pricing.salePrice) {
      return "";
    }

    let html =
      '<div class="product-price flex flex-column" itemprop="offers" itemscope itemtype="http://schema.org/AggregateOffer">' +
      '<meta itemprop="priceCurrency" content="AED">' +
      '<meta itemprop="lowPrice" content="' +
      escapeAttribute(formatPriceNumber(pricing.salePrice)) +
      '">';

    if (pricing.rsp) {
      html +=
        '<meta itemprop="highPrice" content="' +
        escapeAttribute(formatPriceNumber(pricing.rsp)) +
        '">';
    }

    html +=
      '<span class="product-price__price flex align-items-end color-text-primary h2 weight-bold" data-ref="productPrice">' +
      renderMoneyWithDirham(pricing.salePrice) +
      "</span>";

    if (pricing.savings && pricing.savings > 0) {
      html +=
        '<span class="product-price__saving color-error weight-bold">' +
        '<span data-ref="productSaving" class="flex align-items-center">' +
        renderMoneyWithDirham(pricing.savings) +
        " Off RSP</span></span>";
    }

    html += "</div>";
    return html;
  }

  // Badge image URL(s) indexed by KartmaX in `meta_product_badges`
  // (e.g. half-price-rrp.png). Accepts a single URL, an array of URLs,
  // or a JSON-encoded array. Returns "" when no valid URL is present.
  function renderProductBadgeImageHtml(product) {
    let raw = product && product.meta_product_badges;

    if (typeof raw === "string" && raw.trim().charAt(0) === "[") {
      try {
        raw = JSON.parse(raw);
      } catch (error) {
        // Not JSON — treat as a plain URL string.
      }
    }

    const urls = (Array.isArray(raw) ? raw : [raw])
      .map(function (value) {
        return typeof value === "string" ? value.trim() : "";
      })
      .filter(function (value) {
        return /^https?:\/\//i.test(value) || value.indexOf("//") === 0;
      });

    if (!urls.length) {
      return "";
    }

    return (
      '<div class="kartmax-product-badge-image">' +
      urls
        .map(function (url) {
          return (
            '<img class="kartmax-product-badge-image__img" src="' +
            escapeAttribute(url) +
            '" alt="" loading="lazy" decoding="async">'
          );
        })
        .join("") +
      "</div>"
    );
  }

  function renderProducts(node, products, config, appendProducts) {
    if (!products.length) {
      if (!appendProducts) {
        node.innerHTML =
          '<p class="kartmax-collection-page__empty">No products found for this collection.</p>';
      }
      return;
    }

    // position continues across Load More pages.
    const existingCardCount = appendProducts
      ? node.querySelectorAll(".kartmax-collection-page__card").length
      : 0;

    const productCardsHtml = products
      .map(function (product, index) {
        const productUrl = productHref(product) || "#";
        const imageUrl = resolveProductImageUrl(product);
        const pricing = resolveProductPricing(product);
        const handle = resolveProductHandle(product);
        // Badge image (meta_product_badges) takes priority over the text badge.
        // If an image exists, only the image is shown in the badge slot.
        const badgeImageHtml = renderProductBadgeImageHtml(product);
        const badgeHtml = badgeImageHtml
          ? '<div class="product-card-badges product-card-badges--image">' +
            badgeImageHtml +
            "</div>"
          : pricing.badge
            ? '<div class="product-card-badges">' +
              '<span class="product-card-badges__badge product-card-badges__badge--sale">' +
              escapeHtml(pricing.badge) +
              "</span></div>"
            : "";
        const image = imageUrl
          ? '<img class="product-card__image" src="' +
            escapeAttribute(imageUrl) +
            '" alt="' +
            escapeAttribute(product.name || "Product") +
            '" loading="lazy">'
          : '<div class="product-card__image product-card__image--placeholder">No image</div>';
        const priceHtml = renderProductPriceHtml(pricing);
        // same tracking attributes as the search page
        // cards, read by KartmaxSearchAttribution for product_click / add_to_cart.
        const trackingIds = getProductTrackingIds(product);
        const cardPosition = String(existingCardCount + index + 1);
        const skuValue = product.sku || product.variant_sku || "";

        // URL + name help recover Shopify handle when Kartmax url_key 404s
        const wishlistHtml = handle
          ? '<div class="wishlist-hero-custom-button wishlisthero-floating" data-kartmax-wishlist data-product-handle="' +
            escapeAttribute(handle) +
            '" data-product-url="' +
            escapeAttribute(productUrl) +
            '" data-product-name="' +
            escapeAttribute(product.name || "") +
            '" data-wlh-mode="icon_only" data-wlh-view="Collection" style="left: auto;"></div>'
          : "";

        return (
          '<article class="product-card kartmax-collection-page__card" role="listitem"' +
          ' data-kartmax-position="' +
          escapeAttribute(cardPosition) +
          '" data-kartmax-product-id="' +
          escapeAttribute(trackingIds.variantId) +
          '" data-kartmax-group-id="' +
          escapeAttribute(trackingIds.groupId) +
          '">' +
          wishlistHtml +
          '<div class="product-card__image-container">' +
          '<a class="product-card__image-link" href="' +
          escapeAttribute(productUrl) +
          '" aria-label="' +
          escapeAttribute(product.name || "Product") +
          '">' +
          image +
          "</a>" +
          badgeHtml +
          '<div class="product-card-quick-add-trigger">' +
          '<button type="button" class="product-card-quick-add-trigger__button" data-kartmax-add-to-cart data-product-handle="' +
          escapeAttribute(handle) +
          '" data-product-url="' +
          escapeAttribute(productUrl) +
          '" data-kartmax-variant-id="' +
          escapeAttribute(trackingIds.variantId) +
          '" data-kartmax-group-id="' +
          escapeAttribute(trackingIds.groupId) +
          '" data-kartmax-price="' +
          escapeAttribute(pricing.salePrice != null ? String(pricing.salePrice) : "") +
          '" data-kartmax-sku="' +
          escapeAttribute(String(skuValue)) +
          '">' +
          TROLLEY_ICON_SVG +
          '<span class="visually-hidden">Add to cart</span>' +
          "</button></div></div>" +
          '<div class="product-card__information">' +
          '<a class="product-card__title color-text-primary" href="' +
          escapeAttribute(productUrl) +
          '">' +
          escapeHtml(product.name || "Untitled product") +
          "</a>" +
          '<div class="product-card__bottom-container">' +
          '<div class="product-card__price-container">' +
          priceHtml +
          "</div>" +
          '<a class="product-card__cta button button--secondary button--small" href="' +
          escapeAttribute(productUrl) +
          '">' +
          '<span class="hidden-below-tablet">View product</span>' +
          '<span class="hidden-above-tablet">View</span>' +
          "</a></div></div></article>"
        );
      })
      .join("");

    if (appendProducts) {
      node.insertAdjacentHTML("beforeend", productCardsHtml);
    } else {
      node.innerHTML = productCardsHtml;
    }
  }

  // Product ids for the card tracking attributes (same field order as the
  // search page).
  function getProductTrackingIds(product) {
  if (!product || typeof product !== "object") {
    return { variantId: "", groupId: "" };
  }

  var variantId =
    product.id_product ??
    product.id ??
    product.product_id ??
    product.variant_id ??
    product.variantId ??
    "";
  var groupId =
    product.group_id ??
    product.groupId ??
    product.product_group_id ??
    "";

  return {
    variantId: variantId == null ? "" : String(variantId),
    groupId: groupId == null ? "" : String(groupId),
  };
}

  // product_click + add_to_cart tracking on the
  // collection page. Reuses the shared KartmaxSearchAttribution module (same as
  // the search page); it only sends events when the page URL has ?q=.
  function bindGridEventTracking(gridNode) {
    if (!gridNode) {
      return;
    }

    function bind() {
      const attribution = window.KartmaxSearchAttribution;
      const bindGrid =
        attribution &&
        (attribution.bindProductGridTracking || attribution.bindSearchGridTracking);
      if (typeof bindGrid !== "function") {
        return false;
      }
      bindGrid(gridNode, {
        cardSelector: ".product-card.kartmax-collection-page__card",
      });
      return true;
    }

    if (bind() || gridNode.dataset.kmxTrackingRetry === "true") {
      return;
    }

    // Attribution script may load after this one — retry once the page has loaded.
    gridNode.dataset.kmxTrackingRetry = "true";
    if (document.readyState === "complete") {
      window.setTimeout(bind, 0);
    } else {
      window.addEventListener("load", bind, { once: true });
    }
  }

  // Legacy names still set by the theme cart script. Read only as a fallback,
  // so quick add keeps working until that script uses the functional names
  // (window.KartmaxProductCardActions, KartmaxCart.__isThemeCart). Remove once
  // it has been renamed.
  var LEGACY_CARD_ACTIONS_GLOBAL = "__KartmaxSantosh";
  var LEGACY_THEME_CART_FLAG = "__santoshThemeCart";
  var LEGACY_QUICK_ADD_BOUND_KEY = "santoshAtcBound";

  // Product-card actions API (quick add + wishlist).
  function getProductCardActionsApi() {
    return window.KartmaxProductCardActions || window[LEGACY_CARD_ACTIONS_GLOBAL] || null;
  }

  // True when KartmaxCart is the theme's own cart API.
  function isThemeCartApi(cart) {
    return Boolean(cart && (cart.__isThemeCart === true || cart[LEGACY_THEME_CART_FLAG] === true));
  }

  // Prefer the product-card actions API (CDN-safe); never use the CDN binder.
  function bindProductCardActions(gridNode) {
    const cardActions = getProductCardActionsApi();
    if (
      cardActions &&
      typeof cardActions.bindProductCardActions === "function"
    ) {
      cardActions.bindProductCardActions(gridNode);
      return;
    }

    if (
      window.KartmaxCart &&
      isThemeCartApi(window.KartmaxCart) &&
      typeof window.KartmaxCart.bindProductCardActions === "function"
    ) {
      window.KartmaxCart.bindProductCardActions(gridNode);
      return;
    }

    // Bound flag (legacy key still honoured, see LEGACY_QUICK_ADD_BOUND_KEY).
    if (
      !gridNode ||
      gridNode.dataset.kartmaxQuickAddBound === "true" ||
      gridNode.dataset[LEGACY_QUICK_ADD_BOUND_KEY] === "true"
    ) {
      return;
    }
    gridNode.dataset.kartmaxQuickAddBound = "true";
    gridNode.dataset.kartmaxCartBound = "true";
    gridNode.addEventListener("click", function (event) {
      if (!(event.target instanceof Element)) {
        return;
      }
      const button = event.target.closest("[data-kartmax-add-to-cart]");
      if (!button) {
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      const handle = button.getAttribute("data-product-handle") || "";
      const fallbackUrl = button.getAttribute("data-product-url") || "";
      const originalHtml = button.innerHTML;
      const addFn =
        (cardActions && cardActions.addProductByHandle) ||
        (window.KartmaxCart && window.KartmaxCart.addProductByHandle);
      if (typeof addFn !== "function") {
        if (fallbackUrl && fallbackUrl !== "#") {
          window.location.href = fallbackUrl;
        }
        return;
      }
      const proxy = {
        get disabled() {
          return button.disabled;
        },
        set disabled(value) {
          button.disabled = Boolean(value);
        },
        setAttribute: function (name, value) {
          button.setAttribute(name, value);
        },
        removeAttribute: function (name) {
          button.removeAttribute(name);
        },
        get textContent() {
          return button.textContent;
        },
        set textContent(value) {
          const text = String(value || "").trim();
          // loader instead of Adding/Added text.
          if (/^adding/i.test(text) || /^added$/i.test(text)) {
            button.disabled = true;
            button.setAttribute("aria-busy", "true");
            button.innerHTML =
              '<span class="kartmax-atc-loader" aria-live="polite" aria-label="Adding to cart">' +
              '<span class="kartmax-atc-spinner" aria-hidden="true"></span></span>';
            return;
          }
          button.disabled = false;
          button.removeAttribute("aria-busy");
          button.innerHTML = originalHtml;
        },
        get innerHTML() {
          return button.innerHTML;
        },
        set innerHTML(value) {
          if (value === originalHtml) {
            button.disabled = false;
            button.innerHTML = originalHtml;
            return;
          }
          button.innerHTML = value;
        },
      };
      addFn(handle, { button: proxy, fallbackUrl: fallbackUrl });
    });

    // Fallback path must still hydrate wishlist (CDN cart may not expose binder).
    if (
      cardActions &&
      typeof cardActions.initWishlistButtons === "function"
    ) {
      cardActions.initWishlistButtons(gridNode);
    } else if (
      window.KartmaxCart &&
      typeof window.KartmaxCart.initWishlistButtons === "function"
    ) {
      window.KartmaxCart.initWishlistButtons(gridNode);
    }
  }

  function renderLoadMore(node, state, totalPages, shownProducts, total, onChange) {
    if (!node || totalPages <= 1) {
      if (node) {
        node.innerHTML = "";
      }
      return;
    }

    const currentPage = state.page || 1;
    const progress = total > 0 ? Math.min(100, (shownProducts / total) * 100) : 0;
    const buttonHtml = currentPage < totalPages
      ? '<button type="button" class="kartmax-collection-page__page-btn" data-page="' +
        (currentPage + 1) +
        '">Load More</button>'
      : "";

    node.innerHTML =
      '<span class="kartmax-collection-page__page-label">Showing ' +
      shownProducts +
      " of " +
      total +
      "</span>" +
      '<span class="kartmax-collection-page__progress" aria-hidden="true">' +
      '<span class="kartmax-collection-page__progress-value" style="width: ' +
      progress.toFixed(2) +
      '%"></span></span>' +
      buttonHtml;

    const button = node.querySelector("[data-page]");
    if (button) {
      button.addEventListener("click", function () {
        button.disabled = true;
        button.setAttribute("aria-busy", "true");
        button.textContent = "Loading…";
        onChange(Number(button.getAttribute("data-page") || "1"));
      });
    }
  }

  // scroll PLP to top (clear of sticky header)
  function scrollToCollectionResults(container) {
    if (!container || typeof window.scrollTo !== "function") {
      return;
    }

    const target =
      container.querySelector(".kartmax-collection-page__main") ||
      container.querySelector("[data-kartmax-grid]") ||
      container;
    const wrap = document.querySelector("site-header-wrapper, .site-header-wrapper");
    const headerOffset = wrap ? wrap.getBoundingClientRect().height : 0;
    const top =
      target.getBoundingClientRect().top +
      (window.pageYOffset || document.documentElement.scrollTop || 0) -
      headerOffset -
      12;

    window.scrollTo({
      top: Math.max(0, top),
      behavior: "smooth",
    });
  }

  function buildFilterValue(option) {
    const code = option.code || "";
    const value = option.value_code || option.value_key || option.value || "";
    if (!code || !value) {
      return "";
    }

    return code + "~" + value;
  }

  function productHref(product) {
    if (product.url) {
      try {
        const parsed = new URL(product.url, window.location.origin);
        if (parsed.origin === window.location.origin) {
          return parsed.pathname + parsed.search + parsed.hash;
        }
        return product.url;
      } catch (error) {
        return product.url;
      }
    }

    if (product.url_key) {
      return "/products/" + product.url_key;
    }

    const colorOption =
      Array.isArray(product.color_options) && product.color_options.length
        ? product.color_options[0]
        : null;
    if (colorOption && colorOption.url_key) {
      return "/products/" + colorOption.url_key;
    }

    const query = product.name || product.sku || "";
    return "/search?q=" + encodeURIComponent(query) + "&type=product";
  }

  function formatResultsSummary(total, shown) {
    return "Showing " + shown + " of " + total + (total === 1 ? " product" : " products");
  }

  function escapeHtml(value) {
    return String(value)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#39;");
  }

  function escapeAttribute(value) {
    return escapeHtml(value);
  }
})();